import store from '@/store'

export default async (to, from, next) => {
  const appTitle = process.env.VUE_APP_TITLE

  await store.dispatch('auth/getUserLoggedin')

  if (to.name !== 'maintenance' && store.state.maintenance) {
    next({ name: 'maintenance' })
  } else {
    next()
  }

  /* Store 'from' and 'to' router info */
  store.dispatch('navigation/saveToFrom', {to, from})

  document.title = to.meta.title ? to.meta.title : `${appTitle} - Agência online de viagens a negócios`

  if ((to.name === 'paymentsuccess' && from.name !== 'checkout')) {
    next({ name: 'home' })
  }

  if (store.state.auth.isLoggedIn) {
    if (store.state.auth.user.password_expired) {
      next({name: 'password_change'})
    } else if (['login', 'signup', 'forgot_password', 'password_reset'].indexOf(to.name) !== -1) {
      next({ name: 'home' })
    } else {
      next()
    }
  } else if (to.meta.requiresAuth) {
    next({ name: 'login' })
  } else {
    next()
  }
}
